export interface SaasConfig {
    companyId: string
    profile: { id: string, name: string }
    name: string
    settings: Setting[]
    configurations: ConfigurationSaaS[]
    serviceTypes: ServiceType[]
    transportCompanyId: string
}

export interface Setting {
    id: SettingId
    description: string
    active: boolean
}

export interface ConfigurationSaaS {
    id: ConfigurationSaaSId
    description?: string
    enabled?: boolean
    data: Object
}

export enum SettingId {
    CREATE_SERVICE_PUBLIC_BY_DEFAULT = 'createServicePublicByDefault',
    USE_TRAVEL_EXPENSES = 'useTravelExpenses',
    OWN_FLEET = 'ownFleet',
    ENABLE_CONTAINER_INSPECTION_BY_DOCUMENT = 'enableContainerInspectionByDocument',
    ENABLE_CONTAINER_INSPECTION_BY_FORM = 'enableContainerInspectionByForm',
    ENABLE_VEHICLE_INSPECTION_BY_DOCUMENT = 'enableVehicleInspectionByDocument',
    ENABLE_VEHICLE_INSPECTION_BY_FORM = 'enableVehicleInspectionByForm',
    USE_EVIDENCE_TO_GUIDES = 'useEvidenceToGuides',
    AUTOMATIC_SATELLITE_TRACKING = 'automaticSatelliteTracking',
    REQUIRES_PRE_VALIDATION = 'requiresPreValidation',
    PREBILL_REQUIRES_VALIDATION = 'prebillRequiresValidation',
    CONSOLIDATE_BENEFICIARY_PAYMENTS = 'consolidateBeneficiaryPayments',
}

export enum ConfigurationSaaSId {
    ROUTE_DETOUR = 'routeDetour',
    TRANSPORT_COMPANY_BLACK_LIST = 'transportCompanyBlackList',
    RISK_PROFILE = 'riskProfile',
}

/**
 * Contenido de `data` en la configuración `riskProfile`. Los umbrales son "mayor o igual" y no
 * tienen valor por defecto: sin `threshold` el valor declarado no clasifica nada.
 */
export interface RiskProfileConfigData {
    /** Umbral de riesgo alto (COP). Nombre histórico de la clave, se conserva por compatibilidad. */
    threshold?: number
    /** Umbral de riesgo medio (COP). Solo tiene sentido acompañado de `threshold`. */
    mediumThreshold?: number
    /**
     * Viajes previos que se le exigen al vehículo para llevar un servicio de riesgo medio. Vacío = no
     * se exigen viajes. El riesgo bajo nunca exige viajes, por eso no se configura.
     */
    tripsRequiredMedium?: number
    /** Viajes previos exigidos al vehículo para un servicio de riesgo alto. Vacío = no se exigen. */
    tripsRequiredHigh?: number
}

export enum ServiceType {
    FREIGHT_TRANSPORT = 'FREIGHT_TRANSPORT',
    SECURITY_ESCORT = 'SECURITY_ESCORT',
    SATELLITE_LOCK = 'SATELLITE_LOCK',
}